import React, { useState } from 'react'
import { format } from 'date-fns'
import { query, ref, onValue, orderByChild, equalTo } from 'firebase/database'
import database from '../../../firebase/base'
import { MODEL_COLOR } from '../../../model/ModelColor'

const PlanningServeurClient = ({ 
        _displayHours, 
        _converteTimeToHours, 
        _converteTimeToSingleHour, 
        _converteTimeMinutes,
        _convertHoursToTime, 
        _display60Days, 
        _compareDay,
        _compareHours,
        _compareCurrentDayHours,
        _compareBooking,
        booking, 
        valuesPlanning, 
        setDataBooking, 
        staff, 
        datesOff, 
        services,
        user,
        values,
        choiceService,
        choiceDay,
    }) => {

    const [showDay, setShowDay] = useState(0)
    let m = 1
    let z = 10 

    const _compareHoursStaff = (day,hours,dayopen,amOpen,pmOpen,ams,ame,pms,pme) => {
        const array = []
        // console.log('PlanningServeur _compareHoursStaff ',day,hours,dayopen,amOpen,pmOpen,ams,ame,pms,pme)

        if (dayopen === true) {
            if (amOpen === true && hours >= ams && hours < ame) {
                array.push('true')
            }
            if (pmOpen === true && hours >= pms && hours < pme) {
                array.push('true')
            }
        }
        return array
    }

    // METHOD HOURS
    const _displayHours24 = () => {
        const array = []
        for (let i = 0; i < 24; i++) {
            array.push(i)
        }
        return array
    }

    const _displayMinutes = () => {
        const array = []
        for (let i = 0; i < 4; i++) {
            array.push(i)
        }
        return array
    }
 
    return ( 
        <div style={{ marginTop:'8.5rem'}}>

            {/* DISPLAY DAYS */}
            {_display60Days().map((d,i) => (

                // FILTRER LA DATE // FILTER DATE WITH DATE CHOICE 
                d.date === choiceDay &&

                <div key={'d'+i}>

                    {/* AFFICHER LA DATE // DISPLAY DATE */} 
                    <div className='text-center pb-3 row mb-3'>
                            <div 
                                data-bs-toggle="modal" 
                                data-bs-target="#modalListDays" 
                                className='border-top pt-2'
                                style={{ top: "8rem", position: "fixed", width: "100%", backgroundColor:'white' }}
                            ><span style={{ display:'inline-block' }}>{d.dateShow}<i className="bi bi-chevron-compact-down ms-3"></i></span>
                            </div>
                    </div>

                    <div className='pt-2'>

                        {/* UN STAFF A T IL ÉTÉ CHOSI / ARE THERE STAFF SELECTED */}
                        {staff.filter(st => valuesPlanning.idStaff ? st.id === valuesPlanning.idStaff : st.id).map(st => (

                            // DAY IS DATE OFF ?
                            datesOff.filter(d => d.idStaff === st.id && d.date >= d.startDate && d.date <= d.endDate ).length === 0 &&
                            
                            // COMPARE CURRENT DATE AND DAYS * NBR WEEK 
                            d.date <= _compareDay(st.nbrWeeks) &&

                            <div className=' border-top'> 

                                {/* SHOW 24 HOURS */}
                                {_displayHours24().filter(ho => ho > 7 && ho < 20).map(ho => (

                                    <div key={'hours'+ho} className='row'>

                                        <div 
                                            className='col-2 border-top border-dark text-center' 
                                            style={{backgroundColor:'#'+st.circleColor, paddingTop:'2.2rem' }}
                                        >{ho}</div>
                                    
                                        <div className='col row'>
                                        {/* SHOW MINUTES */}
                                        {_displayMinutes().map(mi => (

                                            _compareHoursStaff(
                                                d.day,
                                                (ho*4)+mi,
                                                st[d.day+'open'],
                                                st[d.day+'amOpen'],
                                                st[d.day+'pmOpen'],
                                                _convertHoursToTime(st[d.day+'hoursAMStart'],st[d.day+'minutesAMStart']),
                                                _convertHoursToTime(st[d.day+'hoursAMEnd'],st[d.day+'minutesAMEnd']),
                                                _convertHoursToTime(st[d.day+'hoursPMStart'],st[d.day+'minutesPMStart']),
                                                _convertHoursToTime(st[d.day+'hoursPMEnd'],st[d.day+'minutesPMEnd'])
                                            ).map(c => c).length === 0 ? 

                                                <div className='border-top' style={{fontSize:13, paddingTop:'0.3rem', height:'2rem', backgroundColor:MODEL_COLOR.lightGrey}}>{_converteTimeMinutes((ho*4)+mi)}</div>
                                            :
                                                <>
                                                    {/* FILTRER SI RESERVATION / FILTER IF BOOKING */}
                                                    {booking.filter(b => b.id === d.dateInt+st.id+[(ho*4)+mi]).length === 0 ? 

                                                        <div  
                                                            key={['hours'+ho+'minutes'+mi]}  
                                                            data-bs-toggle="modal"  
                                                            data-bs-target="#modalAddBooking" 
                                                            className='divColor border-top'
                                                            type='button'
                                                            style={{
                                                                fontSize:13, 
                                                                height:'2rem', 
                                                                paddingTop:'0.3rem',
                                                                verticalAlign:'middle',
                                                            }}
                                                            onClick={() => setDataBooking({
                                                                date:d.date,
                                                                dateInt:d.dateInt,
                                                                dateShow:d.dateShow,
                                                                hours:(ho*4)+mi,
                                                                idStaff:st.id, 
                                                                nameStaff:st.nameStaff,
                                                                surnameStaff:st.surnameStaff,
                                                            })}
                                                        >{_converteTimeMinutes((ho*4)+mi)}

                                                        </div> 
                                                    : 
                                                        

                                                        booking.filter(b => b.id === d.dateInt+st.id+[(ho*4)+mi]).map(b =>  
                                                            <div  
                                                                key={['hours'+ho+'minutes'+mi]}  
                                                                style={{backgroundColor:MODEL_COLOR.lightGreen, height:'2rem' }}
                                                                className={b.occurence === 0 && 'border-top'}
                                                                data-bs-toggle="modal" 
                                                                data-bs-target="#modalConfirm" 
                                                                onClick={() => setDataBooking({idStandard:b.idStandard,hours:b.hours,duration:b.durationService})}
                                                            ><span style={{ fontSize:13, paddingTop:'0.3rem' }}>{_converteTimeMinutes((ho*4)+mi)}</span> 
                                                                    {b.occurence === 0 &&
                                                                        '   ' +
                                                                        b.nameService + ' ' 
                                                                        + b.durationService 
                                                                        +'min - ' 
                                                                        + b.surnameClient + ' ' 
                                                                        + b.nameClient+ ' '
                                                                    }
                                                            </div>
                                                        )  
                                                    }
                                                </>

                                        ))}

                                        </div>

                                    </div>
                                    
                                ))}

                                <div className='mt-3' />
                            </div>
                        ))}

                    </div>

                </div>
            
            ))}
            
        </div>
    )
}

export default PlanningServeurClient



